import { inject, injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TollAreaModel } from "@/core/models/toll-area/toll-area.model";
import { AddressRepo } from "../address.repo";
import { TableRepo } from "../table.repo";
import { UserRepo } from "../user.repo";

interface _TollAreaGetParams {
    search?: string
    provinceId?: string
    districtId?: string
    wardId?: string
}


interface _TollAreaStatisticParams {
    search?: string,
    provinceId?: string,
    districtId?: string,
    wardId?: string,
    month?: string,
    year?: string,
    tollAreaId?: number
}
 
export interface TollAreaStatistics {
    districtName: string;
    wardName: string;
    tollAreaName: string;
    districtId: string;
    wardId: string;
    tollAreaId: string;
    tongSoKhachHang: number;
    soLuongCaiApp: number;
    tongTienPhaiDong: number;
    tongTienDaDong: number;
    soLuongHoaDon: number;
    tongLuongNuoc: number;
    tongTienTruocThue: number;
    tongThue: number;
    tongThueBVMT: number;
    tongDoanhThu: number;
    tongTienGiamGia: number;
    tongPhaiThu: number;
    daThu: number;
    chuaThu: number;
    soHoaDonDaThu: number;
    soHoaDonChuaThu: number;
}


@injectable()
export class TollAreaRepo extends TableRepo<TollAreaModel> {
    @inject(AddressRepo)
    private addressRepo!: AddressRepo;

    @inject(UserRepo)
    private userRepo!: UserRepo;

    constructor() {
        super("/api/TollArea");
    }

    async getData(index: number, params: _TollAreaGetParams, pageSize = 10): Promise<ApiPage<TollAreaModel>|null> {
        const result = await super.getData(index, params, pageSize)
        if (result) {
            const data: TollAreaModel[] = [];
            const users = await this.userRepo.getFromFactory()
            for (const record of result.data) {
                const [province, district, ward] = await Promise.all([
                    this.addressRepo.getProvince(record.provinceId),
                    this.addressRepo.getDistrict(record.districtId),
                    this.addressRepo.getWard(record.wardId),
                ])
                const managerName = users.find(user => user.id === record.managerId)?.fullName??"";
                const readerName = users.find(user => user.id === record.readerId)?.fullName??"";
                const tollCollectorName = users.find(user => user.id === record.tollCollectorId)?.fullName??"";
                const populatedRecord: TollAreaModel = {
                    ...record,
                    provinceName: province?.name,
                    districtName: district?.name,
                    wardName: ward?.name,
                    managerName,
                    readerName,
                    tollCollectorName,
                };
                data.push(populatedRecord);
            }
            result.data = data;
            return result;
        }
        return null;
    }

    async getAllByWard(wardId: string) {
        try {
            const response = await this.apiRepo.get<ApiPage<TollAreaModel>>(`${this.basepath}/all-by-ward`, {wardId});
            if (response?.code === '00') {
                return response.result.data
            };
        } catch (err) {
            console.log(err);
        }
        return [];
    }

    async getStatistics(params: _TollAreaStatisticParams) {
        const response = await this.apiRepo.get<{data: TollAreaStatistics[]}>(`${this.basepath}/statistics`, params);
        if (response?.result) {
        return response.result.data;
        }
        return null;
    }
}